import Vue from "vue";

import BannerCarouselSlick from "./BannerCarouselSlick.vue";

export function load() {
    const selector = "banner-carousel-slick";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(BannerCarouselSlick, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
